import axios from '../../config/axiosConfig';
import { CREATE_BOBIN_TYPE, GET_BOBIN_TYPES, BOBIN_TYPE_REQUEST, DELETE_BOBIN_TYPE, UPDATE_BOBIN_TYPE, BOBIN_TYPE_REQUEST_FAILURE } from '../types';
import { addMasterInOption, updateMasterInOption } from './master-options-actions';

export const getBobinTypes = (commonMaster) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: BOBIN_TYPE_REQUEST });
            const { auth } = getState();
            let params = { customerId: auth?.user?.Customer_Id };
            if (!auth?.company?.Common_Master) {
                params = { ...params, companyId: auth.company?.id }
            }
            if (commonMaster !== undefined) {
                params = {
                  ...params,
                  companyId: commonMaster ? undefined : auth.company?.id
                };
              }
            return axios.get('/bobin-type/getAll', { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_BOBIN_TYPES, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BOBIN_TYPE_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BOBIN_TYPE_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const createBobinType = (bobinType) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: BOBIN_TYPE_REQUEST });

            return axios.post('/bobin-type/add', bobinType,
                { params: { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id }}).then((response) => {
                    if (response.data) {
                        dispatch({ type: CREATE_BOBIN_TYPE, payload: response.data });
                        dispatch(addMasterInOption('bobinType', response.data));
                    } else {
                        dispatch({ type: BOBIN_TYPE_REQUEST_FAILURE, error: 'Bobin type create failed.' });
                    }
                    return response;
                }).catch((error) => {
                    console.error(error);
                    dispatch({ type: BOBIN_TYPE_REQUEST_FAILURE, error: error.message });
                    throw error;
                });
        } catch (error) {
            console.error(error);
            dispatch({ type: BOBIN_TYPE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const updateBobinType = (id, data) => {
    return async (dispatch, getState) => {
        try {
            const { auth } = getState();
            dispatch({ type: BOBIN_TYPE_REQUEST });
            return axios.put('/bobin-type/update', { id, data }, { params: { userId: auth.user?.id }}).then((response) => {
                if (response.data) {
                    dispatch({ type: UPDATE_BOBIN_TYPE, payload: { id, data: response.data } });
                    dispatch(updateMasterInOption('bobinType', id, response.data));
                } else {
                    dispatch({ type: BOBIN_TYPE_REQUEST_FAILURE, error: 'Bobin Type update failed.' });
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BOBIN_TYPE_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BOBIN_TYPE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const deleteBobinType = (id) => {
    return async (dispatch) => {
        try {
            dispatch({ type: BOBIN_TYPE_REQUEST });
            return axios.delete(`/bobin-type/delete/${id}`).then((response) => {
                if (response.data) {
                    dispatch({ type: DELETE_BOBIN_TYPE, id: id });
                    dispatch(updateMasterInOption('bobinType', id));
                }
                return response;
            }).catch((error) => {
                console.error(error);
                dispatch({ type: BOBIN_TYPE_REQUEST_FAILURE, error: error.message });
                throw error;
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: BOBIN_TYPE_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};